import React from "react";
import { Panel } from "react-bootstrap";
import UpdatePasswordForm from './update-password-form';
import "./update-password.css";

function UpdatePassword() {
  return (
    <div className="update-password">
      <h3>Change Password</h3>
      <Panel>
        <Panel.Heading>New Password</Panel.Heading>
        <Panel.Body>
          <div className="col col-md-6">
            <UpdatePasswordForm/>
          </div>
        </Panel.Body>
      </Panel>
    </div>
  );
}

export default UpdatePassword;



// WEBPACK FOOTER //
// ./src/account/components/update-password.js